export const defaultColDefinition = {
    sortable: true,
    resizable: true,
    width: 150,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
};
